import React, { useEffect, useMemo, useState } from 'react';

import classNames from 'classnames';
import range from 'lodash/range';
import sortBy from 'lodash/sortBy';

const DaySelectionButton = ({
  value,
  onClick,
  isSelected = false,
}) => (
  <button
    type="button"
    className={classNames(
      'h-8',
      { 'bg-brand text-white': isSelected },
      { 'text-brand': !isSelected },
    )}
    onClick={() => onClick(value)}
  >
    {value}
  </button>
)

const DaySelectionGrid = ({
  values = [],
  onValuesSelected = () => {},
}) => {
  const dayValues = useMemo(() => range(1, 32), [])
  const [selectedValues, setSelectedValues] = useState(values);

  const handleDayButtonClick = (value) => {
    if (selectedValues.includes(value)) {
      const newSelectedValues = selectedValues.filter(curr => curr !== value);

      setSelectedValues(newSelectedValues)
      onValuesSelected(newSelectedValues)
    } else {
      const newSelectedValues = sortBy([...selectedValues, value]);

      setSelectedValues(newSelectedValues)
      onValuesSelected(newSelectedValues)
    }
  }

  useEffect(() => {
    onValuesSelected(selectedValues);
  }, [onValuesSelected, selectedValues])

  return (
    <div className="grid grid-cols-7 m-1">
      {
        dayValues.map(dayVal => (
          <DaySelectionButton
            key={`day-selection-${dayVal}`}
            value={dayVal}
            onClick={handleDayButtonClick}
            isSelected={selectedValues.includes(dayVal)}
          />
        ))
      }
    </div>
  )
}

export default DaySelectionGrid;
